import { Collapse as MuiCollapse } from '@mui/material';

const Collapse = ({ expand, children }) => {
  return <MuiCollapse in={expand}>{children}</MuiCollapse>;
};

export default Collapse;
